import React from "react";
import SubmittedAgreement from "../sumitted_agreement/SubmittedAgreement";

const LetterCorrectionAgreement = () => {
  const fileStatus = 7;
  const applicationPath = {
    copyright: "/admin/letter-of-correction-copyright",
    agreement: "/admin/letter-of-correction-agreement",
  };
  
  // Add route to details page
  const detailsRoute = "/admin/letter-of-correction-agreement-details";
  const pageTitle  = "সংশোধনের চিঠি";

  return (
    <SubmittedAgreement
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={detailsRoute}
      pageTitle={pageTitle}
    />
  );
};

export default LetterCorrectionAgreement;
